{
	"title": "Erklärungen",
	"table": {
		"material": "Material",
		"dateOfIssue": "Ausstellungsdatum",
		"quantity": "Menge",
		"carbonSavings": "Kohlenstoffeinsparungen",
		"status": {
			"title": "Status",
			"TransactionProcessing": "Transaktionsverarbeitung",
			"CreatingDeclaration": "Erklärung wird erstellt",
			"GenerationFailed": "Erstellung fehlgeschlagen",
			"ReadyToDownload": "Bereit zum Download"
		}
	},
	"declarationLanguageSelect": {
		"title": "Erklärungssprache",
		"description": "Wählen Sie eine Erklärungssprache aus.",
		"label": "Erklärungssprache",
		"buttonBack": "Zurück",
		"buttonSave": "Speichern"
	},
	"downloadAllLanguageSelect": {
		"title": "Erklärungssprachen",
		"descriptionGlobal": "Wählen Sie eine Sprache für alle Erklärungen aus.",
		"descriptionIndividual": "Oder legen Sie die Sprache für jede Erklärung einzeln fest.",
		"label": "Erklärungssprachen",
		"tableHeaderDeclaration": "Erklärung (Material/Ausstellungsdatum)",
		"tableHeaderLanguage": "Erklärungssprache",
		"buttonBack": "Zurück",
		"buttonDownload": "Erklärungen herunterladen"
	},
	"declarationActions": {
		"changeLanguage": "Erklärungssprache ändern",
		"preview": "Vorschau",
		"download": "Herunterladen",
		"transaction": "Transaktion",
		"showMoreTransactions": "Mehr Transaktionen anzeigen",
		"languageLabel": "Erklärungssprache",
		"downloadAll": "Alle Erklärungen herunterladen"
	}
}
